// Emojis we may animate (VS16 stripped). Shared by the proxy route (allowlist)
// and the client component (URL building).
export const ANIMATED_EMOJI_ALLOWLIST: ReadonlySet<string> = new Set([
  '📡',
  '🫠',
  '🙈',
  '💤',
  '👻',
  '👋',
  '✍',
  '🔍',
  '😴',
  '🌱',
  '🥺',
  '🎲',
  '🔥',
  '🏆',
  '👑',
])

export const animatedEmojiUrl = (emoji: string) => `/api/tg/animated-emoji/${encodeURIComponent(emoji)}`
